import React from "react";
import Navbar from "../Components/Navbar";
import AppCard from "../Components/AppCard";
import "../Styling/Dashboard.css";
import proposalIcon from "../Assets/icon.png";

const Dashboard = () => {
  const userName = "Esteemed User";

  const apps = [
    {
      name: "Proposal Generator",
      description:
        "Create professional, tailored proposals effortlessly in just minutes with this intelligent chatbot. Streamline your workflow, impress clients, and save valuable time with every proposal you generate.",
      tries: 3,
      icon: proposalIcon,
    },
    // Future apps can be added here
  ];

  return (
    <div>
      <Navbar />
      <div className="dashboard-container">
        <h1 className="dashboard-title">Welcome, {userName}</h1>
        <p className="dashboard-subtitle">
          Here's a few of our apps that you can test
        </p>

        <div className="dashboard-apps">
          {apps.map((app, index) => (
            <AppCard
              key={index}
              appName={app.name}
              description={app.description}
              triesRemaining={app.tries}
              icon={app.icon}
              navigateTo="/proposalbot"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
